import { render, staticRenderFns } from "./TaxInfo.vue?vue&type=template&id=62e642ee&"
import script from "./TaxInfo.vue?vue&type=script&lang=js&"
export * from "./TaxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports